import { Article, Demo, Tutorial } from '@app/components/Guide/types/guide.types'
import apiClient from '@app/config/axios.config'

export type TutorialOrDemoArticle =
  | (Tutorial & { contentType: 'tutorials' })
  | (Demo & { id: number; contentType: 'demos' })

export const fetchTutorialsAndDemosArticles = async (): Promise<TutorialOrDemoArticle[]> => {
  const [tutorialsResponse, demosResponse] = await Promise.all([
    apiClient.get('/cms/tutorials', {
      params: {
        populate: {
          sub_tabs: {
            fields: ['slug', 'title'],
            populate: {
              main_topic: {
                fields: ['slug', 'title'],
              },
            },
          },
        },
        sort: ['createdAt:desc'],
        pagination: {
          pageSize: 3,
        },
      },
    }),
    apiClient.get('/cms/demos', {
      params: {
        populate: {
          sub_tabs: {
            fields: ['slug', 'title'],
            populate: {
              main_topic: {
                fields: ['slug', 'title'],
              },
            },
          },
        },
        sort: ['createdAt:desc'],
        pagination: {
          pageSize: 3,
        },
      },
    }),
  ])

  const tutorials = tutorialsResponse.data.data.map((tutorial: Tutorial) => ({
    ...tutorial,
    contentType: 'tutorials' as const,
  }))

  const demos = demosResponse.data.data.map((demo: Demo & { id: number }) => ({
    ...demo,
    contentType: 'demos' as const,
  }))

  return [...tutorials, ...demos]
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 6)
}

export const fetchRecentArticles = async (): Promise<Article[]> => {
  const response = await apiClient.get('/cms/articles', {
    params: {
      populate: {
        sub_tabs: {
          fields: ['slug', 'title'],
          populate: {
            main_topic: {
              fields: ['slug', 'title'],
            },
          },
        },
      },
      sort: ['createdAt:desc'],
      pagination: {
        pageSize: 6,
      },
    },
  })

  return response.data.data
}
